@switch (locatorToolName) {
  @case (locatorToolNames.HealthCenter) {
    <div class="margin-bottom-1">
      <a (click)="aboutThisTool()" href="javascript:void(0)"
         class="usa-link usa-link--semibold text-no-underline hover:text-underline cursor-pointer">
        About this tool<i class="fa-regular fa-info-circle margin-left-05" aria-label="graphic circle information"></i>
      </a>
    </div>
    <div class="margin-bottom-1">
      <a (click)="noteToHrsaHealthCenters()" href="javascript:void(0)"
         class="usa-link usa-link--semibold text-no-underline hover:text-underline cursor-pointer">
        Note to HRSA Health Centers<i class="fa-regular fa-info-circle margin-left-05" aria-label="graphic circle information"></i>
      </a>
    </div>
    <div class="margin-bottom-1">
      <a class="usa-link usa-link--semibold text-no-underline hover:text-underline usa-link--external" 
         href="https://bphc.hrsa.gov/about-health-center-program"
         rel="noopener noreferrer"
         target="_blank">
        About the Health Center program
      </a>
    </div>
    <div>
      <a href="https://www.youtube.com/embed/EmjM7ckNaLg?cc_load_policy=1" target="_blank" class="usa-link usa-link--semibold usa-link--external">
        <i class="fa-solid fa-video margin-right-1"></i>How-to Video</a>
    </div>
  }
  @case (locatorToolNames.HIVMedicalProvider) {
    <div class="margin-bottom-1">
      <a (click)="aboutThisToolHiv()" href="javascript:void(0)"
         class="usa-link usa-link--semibold text-no-underline hover:text-underline cursor-pointer">
         About this tool<i class="fa-regular fa-info-circle margin-left-05" aria-label="graphic circle information"></i>
      </a>
    </div>
    <div>
      <a class="usa-link usa-link--semibold text-no-underline hover:text-underline usa-link--external"
         href="https://ryanwhite.hrsa.gov/about" 
         rel="noopener noreferrer"
         target="_blank">
        About the Ryan White HIV/AIDS Program
      </a>
    </div>
  }
  @case (locatorToolNames.OrganTransplantCenter) {
    <div>
      <a (click)="aboutOrganTransportCenters()" href="javascript:void(0)"
         class="usa-link usa-link--semibold text-no-underline hover:text-underline cursor-pointer">
        About Organ Transplant Centers<i class="fa-regular fa-info-circle margin-left-05" aria-label="graphic circle information"></i>
      </a>
    </div>
  }
  @case (locatorToolNames.MigrantSeasonalHeadStart) {
    <div>
      <a (click)="aboutMigrantAndSeasonal()" href="javascript:void(0)"
         class="usa-link usa-link--semibold text-no-underline hover:text-underline cursor-pointer">
        About the Migrant and Seasonal Head Start Program<i class="fa-regular fa-info-circle margin-left-05" aria-label="graphic circle information"></i>
      </a>
    </div>
  }
  @case (locatorToolNames.HealthCenterControlledNetwork) {
    <div>
      <a (click)="aboutThisTool()" href="javascript:void(0)"
         class="usa-link usa-link--semibold text-no-underline hover:text-underline cursor-pointer">
        About this tool<i class="fa-regular fa-info-circle margin-left-05" aria-label="graphic circle information"></i>
      </a>
    </div>
  }
}
